import { useEffect } from 'react';
import { NetworkStatus } from '@apollo/client';

import noop from 'lodash/noop';
import { Workflow } from 'modules/workflows/types';
import { useOtherWorkflowsTriggeringCurrentWorkflow } from '../../StartNodeEditor.hooks/useOtherWorkflowsTriggeringCurrentWorkflow';
import { LinkedWorkflowsQueryErrorBanner } from './LinkedWorkflowsQueryErrorBanner';
import { NoLinkedWorkflowsBanner } from './NoLinkedWorkflowsBanner';
import { LinkedWorkflowsList } from './LinkedWorkflowsList';
import { LinkedWorkflowsListLoadingSkeleton } from './LinkedWorkflowsListLoadingSkeleton';

interface LinkedWorkflowsData {
  networkStatus: NetworkStatus;
  workflows: Workflow[];
}

type TriggerTypeInputProps = {
  currentWorkflow: Workflow;
  onLoadStatusUpdate?: (data: LinkedWorkflowsData) => void;
  emptyStateComponent?: JSX.Element;
};

export const LinkedWorkflow = ({
  currentWorkflow,
  onLoadStatusUpdate = noop,
  emptyStateComponent,
}: TriggerTypeInputProps) => {
  const { workflowsTriggeringCurrentWorkflow: workflows, networkStatus } =
    useOtherWorkflowsTriggeringCurrentWorkflow(currentWorkflow);

  const hasLinkedWorkflows = !!workflows.length;

  useEffect(() => {
    onLoadStatusUpdate({ networkStatus, workflows });
  }, [hasLinkedWorkflows, networkStatus]);

  if (networkStatus === NetworkStatus.loading) {
    return <LinkedWorkflowsListLoadingSkeleton />;
  }
  if (networkStatus === NetworkStatus.error) {
    return <LinkedWorkflowsQueryErrorBanner />;
  }
  if (!workflows?.length) {
    return emptyStateComponent || <NoLinkedWorkflowsBanner />;
  }
  return <LinkedWorkflowsList workflows={workflows} />;
};

export default LinkedWorkflow;
